import { TeaserEntry } from "../helper/interfaces";
import React from "react";
import { getLinkObjectFromTeaser } from "../helper/link";


interface Data {
  moduleId: string;
  linkList: TeaserEntry[];
  navigate: (id?: string, ressortId?: string, moduleId?: string) => void;
}

function ModuleLinkList(data: Data) {
  const moduleId = data.moduleId;
  const linkList = data.linkList;
  const navigate = data.navigate;

  return (
    <div className="link-list" key={`o-link-list-${moduleId}`} >
      {linkList.map((teaser, index) => {
        const link = getLinkObjectFromTeaser(teaser);

        if(link.internalLink && link.articleId) {
          return (
            <React.Fragment key={`o-link-list-${moduleId}-${index}`}>
              <button className="btn btn-outline-primary link-list__item" onClick={() => navigate(link.articleId, undefined, moduleId)}>
                {teaser.title}
              </button>
            </React.Fragment>
          );
        }
        if(link.internalLink && link.ressortId) {
          return (
            <React.Fragment key={`o-link-list-${moduleId}-${index}`}>
              <button className="btn btn-outline-primary link-list__item" onClick={() => navigate(undefined, link.ressortId, moduleId)}>
                {teaser.title}
              </button>
            </React.Fragment>
          );
        }
        if(link.externalLink) {
          return (
            <React.Fragment key={`o-link-list-${moduleId}-${index}`}>
              <a className="btn btn-outline-primary link-list__item" href={link.externalLink} target="_blank" rel="noopener noreferrer">
                {teaser.title}
              </a>
            </React.Fragment>
          );
        }
      })}
    </div>
  );
}

export default ModuleLinkList;
